import {create} from 'zustand';
import {WithdrawNewInfoType} from '../withdraw/withdraw-service';

export interface WithdrawState {
  // 选中的快捷金额
  selectedAmount: number | null;
  // 提现基础信息
  info: WithdrawNewInfoType | null;

  // Actions
  setSelectedAmount: (amount: number | null) => void;
  setWithdrawInfo: (info: WithdrawNewInfoType | null) => void;
  reset: () => void;
}

const initialState: Pick<WithdrawState, 'selectedAmount' | 'info'> = {
  selectedAmount: 110,
  info: null,
};

export const useWithdrawStore = create<WithdrawState>((set, _get) => ({
  ...initialState,

  setSelectedAmount: (amount: number | null) => set({selectedAmount: amount}),
  setWithdrawInfo: (info: WithdrawNewInfoType | null) => set({info}),
  reset: () => set(initialState),
}));

export default useWithdrawStore;
